import { render, staticRenderFns } from "./SignboardEdit.vue?vue&type=template&id=0f424228&"
import script from "./SignboardEdit.vue?vue&type=script&lang=js&"
export * from "./SignboardEdit.vue?vue&type=script&lang=js&"
import style0 from "./SignboardEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports